import * as React from 'react';
import { Helmet } from 'react-helmet';


/** 頁面SEO */
export function WebMeta({data, tourCode}) {

  const [webMeta, setWebMeta] = React.useState({
    url: null,
    img: null,
    title: null,
    description: null,
  });
  // console.log('webMeta', webMeta);

  React.useEffect(() => {

    let _webMeta = {
      url: `${window.location.origin}/custom-itinerary`,
      img: '',
      title: '客製化旅遊行程｜AI 智慧規劃專屬旅程｜喜鴻假期',
      description: '不知道怎麼玩？喜鴻假期提供 AI 行程規劃服務，輸入目的地、旅遊天數、旅遊偏好，立即生成專屬旅遊行程。自由行或想客製的團體行程都適用。現在就開始打造你的專屬旅程！',
    }

    setWebMeta(_webMeta);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tourCode]);


  return (
    <>
      {
        data.url === null
        ? null
        :
        <Helmet>
          <title>{webMeta.title}</title>
          <meta name='description' content={webMeta.description} />
          <link rel='canonical' href={webMeta.url} />
          <meta property='og:site_name' content='' />
          <meta property='og:type' content='website' />
            <meta property='og:title' content={webMeta.title}/>
          <meta property='og:url' content={webMeta.url} />
          <meta property='og:description' content={webMeta.description} />
          <meta property='og:image' content={webMeta.img} />
            <meta property='og:image' content={webMeta.url} />
        </Helmet>
      }
    </>
  )
}
